/**
 * Checks if the Web/App-API method for file saving is available
 */
const appTriggerSaveAsFileAvailable = function () {
  const available = (
    // api available
    window.App && (
      (typeof window.App.saveAsFile === 'function') ||
      (window.linkOpenerParams?.inWebview && window.linkOpenerParams?.mobileDevice === 'ios' && typeof window.webkit?.messageHandlers?.saveAsFile?.postMessage === 'function')
    )
  )

  return available
}

const Base64EncodeUnicode = function (str) {
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
    return String.fromCharCode('0x' + p1)
  }))
}

/**
 * Triggers a "save file ..." in the app by invoking the Web/App-API
 * method
 */
const appTriggerSaveAsFile = function (filename, blob, binary = true) {
  if (this.appTriggerSaveAsFileAvailable()) {
    try {
      const reader = new FileReader()
      reader.readAsBinaryString(blob)
      reader.onload = function (e) {
        if (reader.result) reader.content = reader.result
        let dataEncoded = ''
        if (binary) {
          dataEncoded = btoa(reader.content)
        } else {
          dataEncoded = Base64EncodeUnicode(reader.content)
        }

        if (window.linkOpenerParams?.inWebview && window.linkOpenerParams?.mobileDevice === 'ios') {
          const fileInfo = {
            fileName: filename,
            data: dataEncoded
          }
          if (window.webkit?.messageHandlers && window.webkit.messageHandlers?.saveAsFile && typeof window.webkit.messageHandlers.saveAsFile?.postMessage === 'function') {
            window.webkit.messageHandlers.saveAsFile.postMessage(fileInfo)
          }
        } else {
          if (typeof window.App?.saveAsFile === 'function') {
            window.App.saveAsFile(filename, dataEncoded)
          }
        }
      }
    } catch (e) {
      console.error(e)
    }
  }
}

export default {
  methods: {
    appTriggerSaveAsFileAvailable,
    appTriggerSaveAsFile,
    Base64EncodeUnicode
  }
}
